import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import { List, ListItem, Box, FormHelperText } from '@material-ui/core'
import { StyledCheckbox } from 'components'
import { Translate } from 'react-localize-redux'
import PropTypes from 'prop-types'

const MuiList = withStyles((theme) => ({
  root: {
    width: '100%',
    display: 'inline-block',
    '& .MuiListItem-root .MuiBox-root': {
      display: 'flex',
    },
    '& .MuiListItem-root': {
      width: 210,
      float: 'left',
      padding: theme.spacing(0),
      alignItems: 'start',
      flexDirection: 'column',
      '& .MuiList-root': {
        paddingLeft: theme.spacing(1),
        '& .MuiListItem-root:first-child .MuiBox-root': {
          display: 'block',
        },
        '& .MuiListItem-root .MuiBox-root': {
          display: 'flex',
        },
        '& .MuiListItem-root': {
          width: '100%',
          float: 'none',
        },
      },
    },
  },
}))(List)

const AgeClassSelector = ({ input, meta, items }) => {
  const onChange = (uuid) => (checked) => {
    if (checked > 0) {
      input.onChange([...input.value, uuid])

      return
    }

    input.onChange(input.value.filter((value) => value !== uuid))
  }

  const isInvalid = meta.touched && meta.error

  return (
    <Box>
      <MuiList>
        {items.map((age) => (
          <ListItem key={age.uuid}>
            <StyledCheckbox
              input={{
                value: input.value.includes(age.uuid),
                onChange: onChange(age.uuid),
              }}
              label={age.name}
            />
          </ListItem>
        ))}
      </MuiList>
      {isInvalid && (
        <FormHelperText type="invalid" error>
          {isInvalid ? <Translate id={`joi.error.${meta.error}`} /> : ''}
        </FormHelperText>
      )}
    </Box>
  )
}

AgeClassSelector.defaultProps = {
  items: [],
}

AgeClassSelector.propTypes = {
  input: PropTypes.shape().isRequired,
  meta: PropTypes.shape().isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
}

export default AgeClassSelector
